const IconPause = (): JSX.Element => {
  return (
    <>
      <path
        clipRule="evenodd"
        d="M9.6,8.4v7.2M14.4,8.4v7.2M22.8,12c0,5.9-4.8,10.8-10.8,10.8S1.2,17.9,1.2,12,6.1,1.2,12,1.2s10.8,4.8,10.8,10.8Z"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        stroke="currentColor"
      />
    </>
  );
};

export default IconPause;
